import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";
import {rentMortgagePaymentStep} from "@/form/helpers/field-choices.js";

let steps = [
    {
        topTitle: '__lower_car_loan_payments__',
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__tell_us_about_current_vehicle__",
        fields: [
            {
                label: '__car_ownership_status__',
                name: 'own_car',
                placeholder: '__select__',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-12',
                choices: [
                    {"text": "__opt_car_refinancing_own__", "value": "own"},
                    {"text": "__opt_car_refinancing_finance__", "value": "finance"},
                    {"text": "__opt_car_refinancing_lease__", "value": "lease"},
                ],
                hideIfHasValue: true,
            },
            {
                label: '__car_value__',
                name: 'car_value',
                placeholder: '25000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 6
                },
            },
            {
                label: '__car_refinancing_balance__',
                name: 'car_debt',
                placeholder: '2500',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 6
                },
            },
            {
                label: '__car_year__',
                name: 'car_year',
                placeholder: '2018',
                type: 'text',
                value: null,
                // carYear first, so letters get the year message rather than the numbers-only one
                validationRules: 'required|carYear|numeric',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    minlength: 4,
                    maxlength: 4
                },
            },
            {
                label: '__car_mileage__',
                name: 'car_mileage',
                placeholder: '65000',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 6
                },
            },
            {
                label: '__car_make__',
                name: 'car_make',
                placeholder: 'Volkswagen',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 50
                },
            },
            {
                label: '__car_model__',
                name: 'car_model',
                placeholder: 'Golf',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-6',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 50
                },
            },
        ],
    },
    {
        // topTitle: `<h3 class="my-3 text-center h2">__lower_car_loan_payments__</h3>`,
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__tell_us_about_current_financing__",
        fields: [
            {
                label: '__car_current_lender__',
                name: 'current_loan_lender',
                placeholder: '__your_current_lender__',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 50
                },
            },
            {
                label: '__car_current_loan_rate__',
                name: 'current_loan_rate',
                // after the number, the way a rate is written (7 %)
                appendInputSpan: '%',
                // typed the way people know it (6.99, 6,99) and rounded to 7 when kept, since lms takes
                // whole numbers only (input-formats.js). The note under the label says so: the box
                // shows 7 once the person leaves it.
                help: '__round_rate__',
                placeholder: '22',
                type: 'text',
                value: null,
                // `rate` also gives phones the number pad with a decimal key, and the box its maxlength
                validationRules: 'required|rate',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
            },
            {
                label: '__car_current_loan_monthly_payment__',
                name: 'current_loan_monthly_payment',
                placeholder: '1850',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 5
                },
            },
            {
                label: '__car_loan_remaining_months__',
                name: 'current_loan_remaining_months',
                placeholder: '24',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 3
                },
            },
        ],
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__car_in_credit_situation__",
        fields: [
            {
                // label: 'Loan Purpose',
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    // {"text": "__opt_1000_less__", "value": "750"},
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text":"__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type',
                placeholder: '__income_type__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_full__", "value":"full_time" },
                    { "text":"__opt_income_type_part__", "value":"part_time" },
                    { "text":"__opt_income_type_self__", "value":"self_employed" },
                    { "text":"__opt_income_type_pension__", "value":"retired" },
                    { "text":"__opt_income_type_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type_other__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type_other',
                placeholder: '__income_type_other__',
                type: 'checkbox',
                value: null,
                validationRules: 'required',
                // fieldInnerClass: 'large-checkbox',
                isMultipleOption: true,
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_other_wsib__", "value":"wsib" },
                    { "text":"__opt_income_type_other_short_term_disability__", "value":"short_term_disability" },
                    { "text":"__opt_income_type_other_long_term_disability__", "value":"long_term_disability" },
                    { "text":"__opt_income_type_other_social_security__", "value":"social_security" },
                    { "text":"__opt_income_type_other_child_tax_benefit__", "value":"child_tax_benefit" },
                    { "text":"__opt_income_type_other_rental_income__", "value":"rental_income" },
                    { "text":"__opt_income_type_other_other__", "value":"other" },
                    { "text":"__opt_income_type_other_none__", "value":"none" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            // if(!app.hasOwnProperty('income_type') || app.income_type != 'other') {
            //     return true;
            // }
            // return false;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income_input__",
        fields: [
            {
                // label: 'Monthly Income',
                label: (app) => {
                    let labelMessage = '__monthly_income__';
                    if(app && app.income_type && ['full_time', 'part_time', 'self_employed'].includes(app.income_type)) {
                        labelMessage = '__monthly_income_employment__';
                    }
                    else if(app && app.income_type && app.income_type == 'retired') {
                        labelMessage = '__monthly_income_pension__';
                    }
                    return labelMessage;
                },
                name: 'monthly_income',
                placeholder: '2500',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 5
                },
                hideIfCondition: (app) => {
                    return app && app.income_type && app.income_type == 'other';
                }
            },
            {
                // label: 'Other Monthly Income',
                label: '__monthly_other_income__',
                name: 'monthly_other_income',
                placeholder: '2500',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 5
                },
                hideIfCondition: (app) => {
                    let invalidOtherIncomeTypes = ['none', 'other'];
                    let selectedOtherIncomeTypes = app.income_type_other ?? [];
                    // we hide this input if income_type_other selected option is just 'none' or 'other'
                    if(selectedOtherIncomeTypes.length == 1 && invalidOtherIncomeTypes.includes(selectedOtherIncomeTypes[0])) {
                        return true;
                    }
                    return false;
                }
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            let invalidOtherIncomeTypes = ['none', 'other'];
            let selectedOtherIncomeTypes = app.income_type_other ?? [];
            let selectedIncomeType = app.income_type ?? null;
            // we hide this step if both fields were hidden
            if(selectedIncomeType == 'other' && selectedOtherIncomeTypes.length == 1 && invalidOtherIncomeTypes.includes(selectedOtherIncomeTypes[0])) {
                return true;
            }
            return false;
        }
    },
    {
        beforeCreate: function() {
        },
        beforeNextStep: function() {
        },
        title: "__do_you_have_proof_of_income__",
        // employment group questions
        fields: [
            {
                // label: 'Time At Job',
                name: 'has_proof_of_income',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
            // console.log('Fields validation and request to Portal/CMI');
        },
        title: "__employer_information__",
        // employment group questions
        fields: [
            {
                label: '__employer_name__',
                name: 'employer',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            {
                label: '__job_title__',
                name: 'job_title',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
        ],
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
            // console.log('Fields validation and request to Portal/CMI');
        },
        title: "__employed_months__",
        // employment group questions
        fields: [
            {
                // label: 'Time At Job',
                name: 'employed_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_employed_months_3_less__", "value":"2" },
                    { "text":"__opt_employed_months_3_6__", "value":"6" },
                    { "text":"__opt_employed_months_6_12__", "value":"12" },
                    { "text":"__opt_employed_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address__",
        fields: [
            {
                // addressLabel: 'Your Address',
                name: 'address',
                placeholder: '',
                type: 'fulladdress',
                fieldOuterClass: 'col-md-8 offset-md-2',
                value: null,
                // validationRules: 'required',
            },
        ],
    },
    {
        beforeCreate: function() {
        },
        beforeNextStep: function() {
        },
        title: "__address_length_months__",
        fields: [
            {
                // label: 'Time At Address',
                name: 'address_length_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     var options = [
        //         'ON','BC','QC'
        //     ];
        //     return !app.address || !app.address.province || !options.includes(app.address.province);
        // }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                name: 'own_home',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    rentMortgagePaymentStep(),
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                // label: 'Citizenship Status',
                name: 'canadian_status',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__", "value":"pr" },
                    { "text":"__opt_cs_work__", "value":"work_permit" },
                    { "text":"__opt_cs_student__", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'dob',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
            },
            // {
            //     // label: 'Credit Auth',
            //     label: false,
            //     name: 'opt_in',
            //     placeholder: '',
            //     type: 'checkbox',
            //     value: null,
            //     // validationRules: 'required',
            //     // fieldOuterClass: 'col-md-10 offset-md-1',
            //     fieldInnerClass: 'large-checkbox',
            //     // choices: [
            //     //     { "text":'__opt_opt_in_consent__', "value":true },
            //     // ]
            //     choices: (app) => {
            //         if(app.projectBrandKey) {
            //             if(app.projectBrandKey == 'lc') {
            //                 return [
            //                     { "text":'__opt_opt_in_consent__', "value":true },
            //                 ];
            //             }
            //             else if(app.projectBrandKey == 'comparehub') {
            //                 return [
            //                     { "text":'__opt_opt_in_consent_by_lc__', "value":true },
            //                 ];
            //             }
            //         }
            //
            //         return [
            //             { "text":'__opt_opt_in_consent_by_comparehub__', "value":true },
            //         ];
            //     },
            // },
        ],
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        textBottomBelowActionButtons: '__credit_history_authorization_1_car_refinancing__'
    },
    {
        // loadingFunction: (app) => {
        //     return [
        //         {
        //             seconds: 4,
        //             message: '<h3 class="my-4 text-center h4 text-muted">Processing...</h3>'
        //         },
        //     ];
        // },
        beforeCreate: 'enablePartialRequestPerStep',
        // beforeNextStep: function() {},
        // beforeCreate: function(app) {
        //     return !!app.verified_phone_number ? 'executeEarlySubmitApplication' : false;
        // },
        beforeNextStep: function() {},
        title: "__sms_verification__",
        fields: [
            {
                // label: 'SMS Verification',
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !app.forceSmsVerification;
        }
    }
];

export default steps;
